import type { NormalizedResponse, Publication } from "../types/source.types";

/**
 * Normalizes various API shapes into a consistent { items, meta } format.
 * It supports:
 *  - Single-key responses (e.g., { online_blog: [...], metadata: {...} })
 *  - Multi-key responses (e.g., { online_news: [...], blogs: [...], metadata: {...} })
 *
 * When `responseKey` is provided, we prefer it. Otherwise, we use the first array key.
 */
export function normalizeResponse(
  raw: any,
  responseKey?: string,
  category?: string,
  subcategoryId?: string,
): NormalizedResponse {
  const { metadata, ...rest } = raw || {};
  const keys = Object.keys(rest).filter((k) => Array.isArray(rest[k]));

  const keyToUse = responseKey && rest[responseKey] ? responseKey : keys[0];

  const rawItems: any[] = keyToUse ? (rest[keyToUse] ?? []) : [];

  const items: Publication[] = rawItems.map((item) => ({
    id: item._id,
    name: item.publication_name,
    category: category as any,
    subcategory: subcategoryId || "",
  }));

  const meta = {
    currentPage: Number(metadata?.current_page ?? 1),
    totalPages: Number(metadata?.total_pages ?? 1),
    hasNext: Boolean(metadata?.has_next ?? false),
    hasPrev: Boolean(metadata?.has_prev ?? false),
    totalItems: Number(metadata?.total_items ?? undefined),
  };

  return { items, meta };
}
